module.exports = __webpack_public_path__ + "img/bell-solid.04ed5437.svg";